import React from "react";
import swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getRegion } from "../../../helpers/getRegion";

import "./TermsAndConditionsModal.scss";

const MySwal = withReactContent(swal);

const TermsAndConditionsModal = ({ closeModal = MySwal.close }) => {
  const { terms } = getRegion();

  return (
    <div className="terms" dangerouslySetInnerHTML={{ __html: terms }}></div>
  );
};

export default TermsAndConditionsModal;
